import PageHeader from "../components/pageHeader";
import deo from "../assets/deo.png";
import "./bishopPage.css";

export default function DeoPage() {
  return (
    <div>
      <div className="soft-red-bg px-4">
        <PageHeader title="DEO in Madras" />
      </div>

      <main className="bishop-page">
        <section className="bishop-profile">
          <div className="bishop-portrait-wrap">
            <img
              src={deo}
              className="bishop-portrait"
              alt="Rt. Rev. Dr. A.Paul Francis Ravichandran, Bishop in Madras"
            />
          </div>

          <div className="bishop-content">
            <p className="bishop-eyebrow">THE DIOCESE OF MADRAS</p>
            <h1 className="bishop-name">Dr. V. Raju</h1>
            <p className="bishop-role">DEO in Madras</p>

            <blockquote className="bishop-quote">
              &ldquo;Finding the formula for success&rdquo;
            </blockquote>

            <div className="bishop-copy">
              <p>
                Dr. V. Raju serves as the Diocesan Educational Officer (DEO) for
                the CSI Diocese of Madras, Church of South India, overseeing
                administration and academic programs across diocesan schools in
                Chennai and neighboring regions.{" "}
              </p>
              <p>
                V. RAJU, a Chemistry teacher for decades and now the headmaster
                of C.S.I. Corley school, has received the Best National Teacher
                Award and recognition as a National Award-winning NSS program
                officer.{" "}
              </p>
              <p>
                <p>
                  Best National Teacher Award for the year 2015 – 2016’ from
                  President Pranab Mukherjee in New Delhi.
                </p>
                Teachers should be patient with slow learners, giving them the
                necessary guidance to help them overcome their problems.{" "}
              </p>
              <p>
                To be able to guide, teachers should first set their mind to
                understanding what lies at the root of a student’s inability to
                study as well as he should, Through simple but different methods
                of teaching, I made Chemistry enjoyable for students, most of
                whom considered it a tough subjec he said for interview in The
                hindu 28/9/2916{" "}
              </p>
            </div>

            <div className="bishop-signature">
              <p>With Guidance and Blessings,</p>
              <p className="bishop-signature-name">
                Dr. V. Raju
              </p>
              <p>DEO in Madras</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
